<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" class="mb10" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div class="simple-row" v-if="checkActionPerm('create')">
            <div class="left">
                <button class="swb-btn swb-btn-small "  @click="addCustTaxPayType(null)">
                    <span>新增</span>
                </button>
            </div>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { checkUserActionPerm } from '../index'
    import{ openCustTaxPayTypeSaveDlg, openCustTaxPayTypeShowDlg } from './dialog'

    import merchtComnApi from '../../api/merchtComn'

    export default {
        name: 'swb-cust-tax-pay-type-list',
        path: '/cust/tax/pay/type/list/get',
        desc: '自定义纳税类型列表',
        data: function () {
            return {
                // 分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                confKey: 'swb-cust-tax-pay-type-list',
                theTableHeight: 550,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "stdValue", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                //
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                // 过滤信息
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                //
                dataList: [],
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.multiSelect = this.checkBox;
            this.multiPageSelect = this.checkBox;
        },
        mounted() {
            //
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.theTableHeight = height;
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-block"], .simple-row'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'actions': function (row, colName, colValue, rowIndex) {
                        let domHtml = '';
                        if(self.checkActionPerm('view')) {
                            domHtml = domHtml + '<a name="view" class="swb-btn swb-btn-link">查看</a>';
                        }
                        if(self.checkActionPerm('modify')) {
                            domHtml = domHtml + '<a name="modify" class="swb-btn swb-btn-link">修改</a>';
                        }
                        if(self.checkActionPerm('delete')) {
                            domHtml = domHtml + '<a name="delete" class="swb-btn swb-btn-link">删除</a>';
                        }
                        return domHtml;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName == 'view') {
                            self.showCustTaxPayType(row.id);
                        } else if(btnName == 'modify') {
                            self.addCustTaxPayType(row.id);
                        } else if(btnName == 'delete') {
                            self.deleteCustTaxPayType(row.id);
                        }
                    }
                });
            },
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getDataList();
            },
            //
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getDataList();
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            getDataList() {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                // 调用查询接口
                merchtComnApi.getCustTaxPayTypeList(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        self.dataList = result.data.rows;
                        self.totalCount = result.data.pagination.totalCount;
                        self.renderTable(self.dataList, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            showCustTaxPayType: function (id) {
                openCustTaxPayTypeShowDlg({id: id});
            },
            addCustTaxPayType: function (id) {
                let self = this;
                openCustTaxPayTypeSaveDlg({id: id}, function (resultData, theDlg) {
                    let theLoad = MsgBox.loading();
                    merchtComnApi.saveCustTaxPayType(resultData, function (result) {
                        theLoad.hide();
                        if(result.type == "info") {
                            //
                            theDlg.close();
                            let title = "保存成功";
                            if(!Utils.isNoB(id)) {
                                title = "修改成功";
                            }
                            MsgBox.success(title);
                            self.getDataList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                })
            },
            deleteCustTaxPayType: function (id) {
                let self = this;
                //弹出确认框
                this.$confirm('确定删除当前纳税类型?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {
                        id: id
                    };
                    let theLoad = MsgBox.loading();
                    merchtComnApi.deleteCustTaxPayType(postData, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            //
                            MsgBox.success("删除成功");
                            self.getDataList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/comn/CustTaxPayTypeList.vue